import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { Observable, ReplaySubject, combineLatest, pipe } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import clone from 'just-clone';
import { LoggingService } from '../../shared/services/logging';
import * as fromDataServices from '../../data-services';
import { Store, select } from '@ngrx/store';
import * as fromLookups from '../../lookups';
import { SelectItem } from 'primeng/api';
import * as fromShared from '../../shared';
import { IUserInfo } from '../../user-info';
import * as fromUser from '../../user-info';
@Component({
    selector: 'ef-vendor-container',
    templateUrl: './vendor-container.component.html',
    styleUrls: ['./vendor-container.component.scss'],
    standalone: false
})
export class VendorContainerComponent implements OnInit {
    VendorModelDS: EntityCollectionService<fromDataServices.Vendor.VendorModel>;
    VendorModel$: Observable<Partial<fromDataServices.Vendor.VendorModel>[]>;
    ManageUsersModelDS: EntityCollectionService<fromDataServices.ManageUsers.LoginModel>;
    ManageUsersModel$: Observable<fromDataServices.ManageUsers.LoginModel[]>;

    employeesSelectItem$: Observable<SelectItem[]>;
    userInfo$: Observable<IUserInfo>;
    directReports$: Observable<fromLookups.IDirectReport[]>;

    process$: Observable<fromShared.Process>;
    active = true;
    ShowErrorSubject = new ReplaySubject<fromShared.Errors.IShowErrors>(1);
    selectedErrorWithStatus$: Observable<fromShared.IStatusMessage>;
    constructor(
        private log: LoggingService,
        public entityServices: EntityServices,
        private store: Store
    ) {
        this.log.verbose({ type: 'VendorContainerComponent::' });
        this.VendorModelDS =
            entityServices.getEntityCollectionService<fromDataServices.Vendor.VendorModel>(
                fromDataServices.Vendor.entityName
            );
        this.ManageUsersModelDS =
            entityServices.getEntityCollectionService<fromDataServices.ManageUsers.LoginModel>(
                fromDataServices.ManageUsers.entityName
            );
    }
    ngOnInit(): void {
        this.VendorModelDS.clearCache();
        this.VendorModelDS.getWithQuery({
            MatchOnName: 'false',
            Only1099: 'false'
        });
        this.ManageUsersModelDS.clearCache();
        this.ManageUsersModelDS.getWithQuery({
            ShowInactive: 'false',
            UserFilterID: '7'
        });

        this.VendorModel$ = this.VendorModelDS.entities$.pipe(
            map(items => [...clone(items)])
        );
        this.ManageUsersModel$ = this.ManageUsersModelDS.entities$.pipe(
            map(items => [...clone(items)])
        );

        this.setupObservables();
        this.setupSubscriptions();
    }
    ngOnDestroy() {
        this.active = false;
    }
    setupObservables() {
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.selectedErrorWithStatus$ = this.store.pipe(
            select(fromShared.Errors.selectErrorWithStatus)
        );
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.directReports$ = this.store
            .pipe(select(fromLookups.getDirectReportsLookup))
            .pipe(map(x => fromShared.uniqBy(x, y => y.EmployeeListID)));

        this.employeesSelectItem$ = combineLatest([
            this.directReports$,
            this.ManageUsersModel$
        ]).pipe(
            // this.directReports$.pipe(
            map(([dr, users]) =>
                dr
                    .filter(
                        y =>
                            y.IsActive === true &&
                            users.find(
                                x => x.EmployeeListID === y.EmployeeListID
                            )?.EUserID !== null
                        // && y.IsValidUser === true
                    )
                    .map(y => ({
                        label: y.EmployeeName,
                        value: y.EmployeeListID
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );
    }

    setupSubscriptions() {
        combineLatest([this.process$, this.ShowErrorSubject])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });

        this.userInfo$
            .pipe(takeWhile(() => this.active))
            .subscribe(userInfo => {
                this.store.dispatch(
                    new fromLookups.LoadDirectReports({
                        user: userInfo,
                        activeOnly: false
                    })
                );
            });
    }

    onSaveVendor($event) {
        this.VendorModelDS.upsert($event);
    }
    onGetVendor($event) {
        this.VendorModelDS.clearCache();
        this.VendorModelDS.getWithQuery($event);
    }
}
